import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExternalLinkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ExternalLink",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.91 5.78c-.07-.16-.16-.3-.28-.41a1.1 1.1 0 0 0-.4-.27c-.14-.06-.3-.09-.47-.09h-7.72c-.7 0-1.26.56-1.27 1.26 0 .7.57 1.27 1.27 1.27h4.64L11.86 18.35a1.272 1.272 0 0 0 1.8 1.8L24.47 9.34v4.64c0 .7.57 1.27 1.27 1.27s1.27-.57 1.27-1.27V6.27c0-.17-.03-.33-.09-.47Zm-4.57 11.91c-.7 0-1.27.57-1.27 1.27v5.15c0 .19-.16.35-.35.35H7.89c-.19 0-.35-.16-.35-.35V11.27c0-.19.16-.35.35-.35h5.15c.7 0 1.27-.57 1.27-1.27s-.57-1.27-1.27-1.27H7.89c-1.59 0-2.88 1.3-2.89 2.89v12.84a2.9 2.9 0 0 0 2.89 2.9h12.86c1.6 0 2.9-1.3 2.9-2.9v-5.14c0-.7-.57-1.27-1.27-1.27h-.03Z"
    })
  }));
};